import { Button, Divider, Form, Input, Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import SvgCom from '../../../components/SvgCom/index.jsx';
import {ReactComponent as CloseSvg} from '../../../assets/svgs/close.svg';
import {ReactComponent as VideoSvg} from '../../../assets/svgs/video.svg';
import { SearchOutlined } from '@ant-design/icons';
import { getShowreelList, postShowreel, putShowreel } from '../../../api/request.js';
import { cn } from '../../../utils/utils.js';
// import { useNavigate } from 'react-router-dom';

const classNames = {
  content: '!p-[18px]',
};

let timeout = null;

const getData = async (search = '', callback) => {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  } else {
    timeout = setTimeout(async () => {
      try {
        const params = {
          page: 1,
          page_size: 10,
          sort: '-created_at',
          search: search
        };
        const response = await getShowreelList(params);
        const {  status, data = {} } = response || {};
        if(status === 'Success') {
          const { items = [] } = data;
          const options = items.map(item => ({label: item.title, value: item.id}));
          callback(options);
        }
      } catch(error) {
        console.log(error);
      }
    }, 300);
  }
};

const AddShowreelWinCom = ({openWin, onClose, clipIds}) => {
  // const nvigate = useNavigate();
  const [ allData, setAllData ] = useState([]);
  const [ showreelId, setShowreelId ] = useState('');
  const [ customName, setCustomName ] = useState('');

  useEffect(() => {
    if(openWin) {
      getData('', setAllData);
    } else {
      setShowreelId('');
      setCustomName('');
    }
  }, [openWin]);

  const handleSearch = async(newValue = '') => {
    getData(newValue, setAllData);
  };

  const handleChange = (newValue) => {
    setShowreelId(newValue);
  };

  // core handler
  const fnHandler = async () => {
    try {
      let tempShowreelId = '';
      if(customName) {
        const params = {
          'title': customName,
          'clip_ids': clipIds
        };
        const result = await postShowreel(params);
        if(result.status === 'Success') {
          const { id } = result.data;
          tempShowreelId = id;
        }
      } else {
        const params = {
          clip_ids: clipIds
        };
        const result = await putShowreel(showreelId, params);
        if(result.status === 'Success') {
          const { id } = result.data;
          tempShowreelId = id;
        }
      }
      if(tempShowreelId) {
        // 进入 showreel 详情
        onClose(false);
        // nvigate('/consumer-theatre-processing/showreel/detail/'+tempShowreelId);
      }
    } catch(error) {
      //
    }
  };

  return (
    <>
      <Modal open={openWin} destroyOnClose onCancel={() => onClose(false)} closeIcon={<SvgCom Svg={CloseSvg} size='20'></SvgCom>} footer={null} centered={true} classNames={classNames}>
        <div className='text-primary'>
          <div className='text-[14px] font-semibold leading-none mb-5'>Add to showreel</div>
          <Form
            name="basic"
            layout="vertical"
            autoComplete="off"
            className='add-showreel-form'
          >
            <Form.Item
              label="Create showreel"
              name="Create showreel"
            >
              <Input disabled={showreelId} value={customName} onChange={(e) => setCustomName(e.target.value)} />
            </Form.Item>

            <Form.Item
              label="Search showreels"
              name="Search showreels"
            >
              <div className='relative'>
                <Select
                  disabled={customName}
                  className="w-full [&_.ant-select-selection-item]:!ml-[25px] [&_.ant-select-selection-search-input]:!ml-[25px]"
                  showSearch
                  allowClear
                  value={showreelId}
                  onSearch={handleSearch}
                  onChange={handleChange}
                  filterOption={false}
                  notFoundContent={null}
                  options={allData}
                ></Select>
                <SearchOutlined className="text-primary absolute top-[10px] left-[10px]" />
              </div>
            </Form.Item>
            <Divider style={{
              borderColor: '#00a32e',
            }}/>
            <div>
              <div className='text-[12px] leading-none font-[500] mb-2'>Most recent showreels</div>
              
              {
                allData.slice(0, 5).map((item, index) => <div key={index} onClick={() => setShowreelId(item.value)} className={cn('relative border flex items-center justify-start mb-2 text-[12px] px-[12px] py-[6px] border-primary rounded-[6px] hover:bg-second cursor-pointer', showreelId === item.value && 'bg-second')}>
                  <SvgCom Svg={VideoSvg} size='14' className='text-primary'></SvgCom>
                  <span className='ml-2'>{item.label}</span>
                </div>)
              }
            </div>
            <Divider style={{
              borderColor: '#00a32e',
            }}/>
            <Form.Item label={null}
              className='flex justify-end'
            >
              <Button htmlType="button" onClick={() => onClose(false)}>
                Cancel
              </Button>
              <Button onClick={fnHandler} type="primary" htmlType="submit" className='ml-3'>
                Add
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default AddShowreelWinCom;